// for native, it works like findNodeHandle
export { findNodeHandle } from 'react-native';
